module.exports = __webpack_public_path__ + "e32fde7db2fb23cf557f731e6d390119.jpg";